import React, { Component } from "react";
import PropTypes from 'prop-types';

class DevOpsFileLink extends Component {
  static propTypes = {
    project: PropTypes.any.isRequired,
    devOpsPath: PropTypes.string.isRequired,
  };

  render = () => {
    const link = `${this.props.project.devOpsRepositoryUrl}?path=${encodeURIComponent(this.props.devOpsPath)}&_a=preview`;

    return (
      <a className="devopsFileLink" title="Modify section" alt="Modify section" href={link} rel="noopener noreferrer" target="_blank">
        <i className='icon-pencil-edit'/>
      </a>
    );
  };
}

export default DevOpsFileLink;
